export const onDownload = async (fileName, filePath) => {
  const element = document.createElement("a");
  const res = await fetch(filePath);
  const blob = await res.blob();
  element.href = URL.createObjectURL(blob);
  element.setAttribute("download", fileName);
  element.click();
};
